module.exports = __webpack_public_path__ + "static/media/broich.21b89b65.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/ExampleCarousel/assets/broich.png
// module id = 447
// module chunks = 0